var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeneralOutdoor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1765 7.99215C11.1765 11.3221 8.8773 12.987 6.14458 13.9527C6.00149 14.0019 5.84605 13.9995 5.70446 13.9461C2.96518 12.987 0.666016 11.3221 0.666016 7.99215V3.33026C0.666016 3.15362 0.735225 2.98423 0.858418 2.85933C0.981611 2.73444 1.1487 2.66427 1.32292 2.66427C2.63672 2.66427 4.27898 1.86509 5.42199 0.852791C5.56116 0.732247 5.73819 0.666016 5.92124 0.666016C6.10428 0.666016 6.28132 0.732247 6.42048 0.852791C7.57006 1.87175 9.20575 2.66427 10.5196 2.66427C10.6938 2.66427 10.8609 2.73444 10.9841 2.85933C11.1073 2.98423 11.1765 3.15362 11.1765 3.33026V7.99215Z",
    stroke: "#6E11B0",
    strokeWidth: 1.33197,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralOutdoor);
export default __webpack_public_path__ + "static/media/general_outdoor.3bf5750a4fca6124aa5d40cec991a02f.svg";
export { ForwardRef as ReactComponent };